<template>
<main class="html-page info-page">
  <section class="page-hero info-hero" data-bloco="informacoes-hero" data-tipo="hero"><div class="container info-hero-grid"><div class="info-hero-copy"><p class="eyebrow" v-html="html(informacoesHero,'iti_nome')"></p><h1 v-html="html(informacoesHero,'iti_resumo1')"></h1><p v-html="html(informacoesHero,'iti_descricao1')"></p></div><div class="info-hero-media"><img v-if="image(informacoesHero)" :src="image(informacoesHero)" alt="Documentos e proteção de dados" @error="hideBrokenImage"></div></div></section>
  <section class="section info-section"><div class="container info-layout-modern" data-bloco="informacoes-lista" data-tipo="lista"><aside class="info-sidebar-modern"><p>Consulte</p><router-link v-for="(item,index) in informacoesLista" :key="itemId(item)" class="info-side-link" :class="{active:selectedItem && itemId(selectedItem)===itemId(item)}" :to="infoRoute(item)"><span>{{ String(index+1).padStart(2,'0') }}</span><div><strong v-html="html(item,'iti_nome')"></strong></div></router-link></aside><div class="info-panel-modern"><article v-if="selectedItem" class="info-content-modern"><span class="tag">Informações</span><h2 v-html="html(selectedItem,'iti_nome')"></h2><div class="info-intro" v-html="html(selectedItem,'iti_descricao1')"></div></article></div></div></section>
  <a class="whatsapp" href="https://wa.me/5551991544590" aria-label="Falar pelo WhatsApp"><span></span></a>
</main>
</template>

<script>
import { contentValue, firstImage, loadScreens, applyPageMeta } from '@/services/contentApi';

export default {
  name: 'InformacoesView',
  data() {
    return {
      informacoesHero: {},
      informacoesLista: [],
    };
  },
  computed: {
    selectedItem() {
      if (!this.informacoesLista.length) return null;
      const routeId = String(this.$route.params.id || '');
      if (routeId) {
        return this.informacoesLista.find(item => String(this.itemId(item)) === routeId) || this.informacoesLista[0];
      }
      return this.informacoesLista[0];
    },
  },
  created() {
    this.loadContent();
  },
  watch: {
    informacoesLista() {
      this.ensureFriendlyRoute();
    },
    '$route.params.id'() {
      this.ensureFriendlyRoute();
      this.applyMeta(this.selectedItem);
    },
    selectedItem(item) {
      this.applyMeta(item);
    },
  },
  methods: {
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    image(source) { return firstImage(source); },
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    text(source, field, fallback = '') {
      return String(contentValue(source, field, fallback)).replace(/<[^>]*>/g, '').trim();
    },
    itemId(item) {
      return item?.itiId || item?.id || item?.ctiId || this.slug(this.text(item, 'iti_nome'));
    },
    slug(value) {
      return String(value || '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'informacao';
    },
    infoRoute(item) {
      return '/informacoes/' + this.itemId(item) + '/' + this.slug(this.text(item, 'iti_nome'));
    },
    applyMeta(item) {
      if (!item) return;
      applyPageMeta({
        title: this.html(item, 'iti_nome'),
        description: this.html(item, 'iti_resumo1') || this.html(item, 'iti_descricao1'),
        image: firstImage(this.informacoesHero),
      });
    },
    infoContent(item) {
      return [
        this.html(item, 'iti_resumo1'),
        this.html(item, 'iti_resumo2'),
        this.html(item, 'iti_descricao1'),
        this.html(item, 'iti_descricao2'),
        this.html(item, 'iti_descricao3'),
        this.html(item, 'iti_descricao4'),
        this.html(item, 'iti_descricao5'),
        this.html(item, 'iti_descricao6'),
      ].filter(Boolean).join(' ');
    },
    ensureFriendlyRoute() {
      if (!this.$route.params.id && this.informacoesLista.length) {
        this.$router.replace(this.infoRoute(this.informacoesLista[0])).catch(() => {});
      }
    },
    async loadContent() {
      const data = await loadScreens([
        { ctiId: 32, key: "informacoesHero", multi: false },
        { ctiId: 33, key: "informacoesLista", multi: true },
      ]);
      Object.assign(this, data);
      this.ensureFriendlyRoute();
      this.applyMeta(this.selectedItem);
    },
  },
};
</script>